import { createContext, useContext } from 'react';
import type { HighlightUrlContextValue } from './types';

export const HighlightUrlContext = createContext<HighlightUrlContextValue>({
  values: {},
  hasHighlightUrl: () => false,
  getHighlightById: () => false,
  reload: async () => false,

  reloadAll: async () => undefined,
});

export const useHighlightUrl = () => useContext(HighlightUrlContext);
